import { render, staticRenderFns } from "./nba-card-modal.vue?vue&type=template&id=706e1a88&scoped=true&lang=pug&%40touchmove=(e)%20%3D%3E%20e.preventDefault()&"
import script from "./nba-card-modal.vue?vue&type=script&lang=js&"
export * from "./nba-card-modal.vue?vue&type=script&lang=js&"
import style0 from "./nba-card-modal.vue?vue&type=style&index=0&id=706e1a88&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706e1a88",
  null
  
)

export default component.exports